// removed by extract-text-webpack-plugin
module.exports = {"deck-import":"_15y4vP1mmUixUAa_PcWdeV","grid-figure":"_19yTCY_8h2Q0nWkDIhk_Ed","header":"et9Vhh765oSDmUBjY3Oc0","error":"WiBeMG3Wh-cgdj_h8Cskx","drop":"_2bK-gzkDVPZm43p32aw6lv","drop-active":"_1Toar6pZl-_H1tAdemRaps","drop-reject":"_2Z7EcltXzzP4Q_Gc1Pn5eE","or-bar":"npavMBPAEQCQOg4rev0QQ","growWidth":"piW7K1LBqcB-412tMVs95"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/ImportDeck.styl
// module id = 470
// module chunks = 0